import { render, staticRenderFns } from "./ModalEliminarMultiplesDocumentos.vue?vue&type=template&id=3f356045&scoped=true&"
import script from "./ModalEliminarMultiplesDocumentos.vue?vue&type=script&lang=js&"
export * from "./ModalEliminarMultiplesDocumentos.vue?vue&type=script&lang=js&"
import style0 from "./ModalEliminarMultiplesDocumentos.vue?vue&type=style&index=0&id=3f356045&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f356045",
  null
  
)

export default component.exports